import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useHistory, useRouteMatch } from "react-router-dom";
import ButtonBase from "../../Buttons/ButtonBase";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { validationSearch } from '../../../utils/validations';
import { pagingQuestion, setCommunityKey } from '../../../store/actions/CommunityAction';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { ESPECIALIDADITEMS } from '../../../utils/ConstantsMain';
import { TextField } from '@material-ui/core';
import "./searchQuestion.scss";
// import categories from "../categories.json";

const useStyles = makeStyles(theme => ({
    autoComplete: {
        display: 'flex',
        justifyContent: 'center'
    },
    inputLabelRoot: {
        transform: 'translate(14px, 16px) scale(1)',
    },
    formHelperTextRoot: {
        margin: '8px 14px',
        marginBottom: 0,
    },
    inputError: {
        border: '1px solid #d74242',
        '&:hover': {
            border: '1px solid #d74242',
        },
    },
    TextField: {
        maxWidth: '576px',
    },
    TextFieldInAnswers: {
        maxWidth: '650px',
    },
    TextField_small: {
        maxWidth: '46%',
    },
}));

const SearchQuestions = ({
    pagingQuestion,
    inAnswers,
    questionId,
    isLawyer,
    setCommunityKey,
}) => {

    const [topicData, setTopicData] = useState()
    const [isValidSearch, setIsValidSearch] = useState(false)
    const classes = useStyles();
    const history = useHistory();
    
    const matchWithAnswers = useRouteMatch(`/comunidad/pregunta/${questionId ? questionId : ''}`);
    
    const formSearchValues = {
        search: "",
    };

    const handleSubmitSearchForm = async (values, { setSubmitting, setFieldError, resetForm }) => {
        try {
            showLoading()
            await pagingQuestion(values.search, 1)
            setCommunityKey(values.search)
            hideLoading()
            if (inAnswers) {
                window.inAnswers = matchWithAnswers.path
                history.push('/comunidad')
            }
        } catch (error) {
            console.log('error', error);
            hideLoading()
        }
    }

    const selectTopicQuestion = (params) => {
        setTopicData(params)
        params && setIsValidSearch(true)
    }

    const handleRenderForm = (props) => {

        const {
            handleSubmit,
            values,
        } = props;

        values.search = topicData

        return (
            <div
                className={
                    inAnswers ?
                    "contentMainSearchAnswers" :
                    isLawyer ?
                    "contentMainSearchLawyer" :
                    "contentMainSearch"
                }
            >
                <div
                    className={
                        inAnswers ?
                        "contentMainSearchAnswers_titleContainer" :
                        isLawyer ?
                        "contentMainSearchLawyer_titleContainer" :
                        ""
                    }
                >
                    <p
                        className={
                            inAnswers ?
                            "titleSearchQuestionAnswers" :
                            isLawyer ?
                            "titleSearchQuestionLawyer" :
                            "titleSearchQuestion"
                        }
                    >
                        Puedes buscar entre las preguntas que los usuarios ya han realizado
                    </p>
                    <p
                        className={
                            inAnswers ?
                            "subTitleQuestionAnswers" :
                            isLawyer ?
                            "subTitleQuestionLawyer" :
                            "subTitleQuestion"
                        }
                    >
                        Ingresa un tópico de tu interés y te mostraremos todas las preguntas que se han realizado acerca del mismo.
                    </p>
                </div>
                <form
                    onSubmit={handleSubmit}
                    className={
                        inAnswers ?
                        "contentMainSearchAnswers_form" :
                        isLawyer ?
                        "contentMainSearchLawyer_form" :
                        "contentMainSearch_form"
                    }
                >
                    <div className='contentMainSearch_inputContainer'>
                        <Autocomplete
                            name="search"
                            options={ESPECIALIDADITEMS}
                            getOptionLabel={option => option}
                            style={{ width: "100%", marginTop: "40px" }}
                            onChange={(event, value) => {
                                selectTopicQuestion(value);
                            }}
                            classes={{ root: inAnswers ? classes.autoComplete : '' }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    value={topicData}
                                    classes={{ root: inAnswers ? classes.TextFieldInAnswers : classes.TextField }}
                                    label="Buscar"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                />
                            }
                        />
                    </div>
                    {!inAnswers ?
                        <ButtonBase
                            type="submit"
                            onClick={handleSubmit}
                            className="searchButton"
                            variant="primary"
                            disabled={!isValidSearch}
                        >
                            Buscar
                        </ButtonBase> : null
                    }
                </form>

            </div>

        )
    }
    return (
        <Formik
            initialValues={formSearchValues}
            validationSchema={validationSearch}
            onSubmit={handleSubmitSearchForm}
            render={handleRenderForm}
        />
    )
}

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    pagingQuestion: (search, page) => dispatch(pagingQuestion(search, page)),
    setCommunityKey: key => dispatch(setCommunityKey(key))
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    role: state.authClient.role
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchQuestions);

